import { AndonData as AdminAndonData } from "01Data/01Admin/Andon";
import { AndonData as UserAndonData } from "01Data/02User/Andon";
import { AccountSettings } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import Copyright from "03AdminPages/99Parts/Copyright";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { CognitoUser } from "amazon-cognito-identity-js";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForceChangePassDialog } from "./useForceChangePassDialg";
import { useTotpDialog } from "./useTotpDialog";

const MyPaper = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(8),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const MyAvatar = styled(Avatar)(({ theme }) => ({
  margin: theme.spacing(1),
  backgroundColor: theme.palette.secondary.main,
}));

const MyForm = styled("form")(({ theme }) => ({
  width: "100%", // Fix IE 11 issue.
  marginTop: theme.spacing(1),
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

const LoginginButton = styled(LoadingButton)(({ theme }) => ({
  margin: theme.spacing(3, 0, 2),
}));

/**
 * 注意書き 文章
 */
const NotesItem = styled(ListItem)(() => ({
  display: "list-item",
  fontSize: "12px",
  paddingLeft: 0,
}));

const LoginPage = () => {
  const a = useContext(AppContext);
  const [addr, setAddress] = useState("");
  const [pass, setPassword] = useState("");
  const [message, setMesasge] = useState("");
  const [errorDetail, setErrorDetail] = useState("");
  const [bProcessing, setProcessing] = useState(false);

  const [loginUser, setLoginUser] = useState<CognitoUser | null>(null);
  const { ForceChangePassDialog, openForceChangePassDialog } =
    useForceChangePassDialog();
  const { TotpDialog, openTotpDialog } = useTotpDialog();
  const [openMsgDialog, setOpenMsgDialog] = useState(false);

  const [passwordVisible, setPasswordVisible] = useState(false);

  const navigation = useNavigate();

  const navToNext = () => {
    // ログイン前のユーザーのデータをクリア
    a.dataUser.andon = new UserAndonData();
    a.dataAdmin.andon = new AdminAndonData();
    // 遷移先へ
    if (a.account.IsAdmin()) {
      navigation("/admin/leakage/");
    } else if (a.account.IsUser()) {
      const to = sessionStorage.getItem("redirect");
      if (to) {
        sessionStorage.removeItem("redirect");
        navigation(to);
      } else {
        navigation("/top/");
      }
    } else {
      navigation("/login/");
    }
  };

  const handleLogin = async () => {
    setProcessing(true);
    const accountSettings = new AccountSettings(addr, pass);
    try {
      // if (!validate(addr)) {
      //   throw new Error("Invalid mail address.");
      // }
      const resp: CognitoUser = await a.account.SignIn(accountSettings);
      // console.log(resp.getUsername() /* sub */);
      setLoginUser(resp);
      if (resp.challengeName === "NEW_PASSWORD_REQUIRED") {
        // パスワード強制変更
        const changePassResult = await openForceChangePassDialog();
        if (changePassResult === "ok") {
          setPassword("");
          setOpenMsgDialog(true);
        }
      } else if (resp.challengeName === "SOFTWARE_TOKEN_MFA") {
        // TOTP 認証
        const result = await openTotpDialog();
        if (result === "ok") {
          // ログイン OK
          await a.account.CheckAccount(resp.getUsername());
          navToNext();
        }
      } else {
        // MFA 非アクティブ
        await a.account.CheckAccount(resp.getUsername());
        navToNext();
      }
    } catch (err: any) {
      if (err?.code === "UserNotConfirmedException") {
        setMesasge("認証コードを入力してください。");
      } else {
        setMesasge("メールアドレスまたはパスワードが違います。");
      }
      const messages = err.toString().split(":");
      if (0 < messages.length) {
        setErrorDetail(
          `詳細: ${messages.length === 1 ? messages[0].trim() : messages[1].trim()}`
        );
      }
      // console.log("ログイン失敗");
      // console.error(err);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <MyPaper>
        <Typography component="h1" variant="h5">
          漏水みはり番監視システム
        </Typography>
        <MyAvatar>
          <LockOutlinedIcon />
        </MyAvatar>
        <Typography component="h1" variant="h5">
          ログイン
        </Typography>
        <MyForm noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="メールアドレス"
            name="email"
            autoComplete="email"
            autoFocus
            inputProps={{ maxLength: 128 }}
            value={addr}
            onChange={(e) => {
              setMesasge("");
              setErrorDetail("");
              setAddress(e.target.value);
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="パスワード"
            type={passwordVisible ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            inputProps={{ maxLength: 128 }}
            value={pass}
            onChange={(e) => {
              setMesasge("");
              setErrorDetail("");
              setPassword(e.target.value);
            }}
            InputProps={{
              endAdornment:
                pass !== "" ? (
                  <IconButton
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ) : null,
            }}
          />
          {0 < message.length ? <ErrorText>{message}</ErrorText> : null}
          {0 < errorDetail.length ? <ErrorText>{errorDetail}</ErrorText> : null}
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "10px",
              fontSize: "0.85rem",
            }}
          >
            <Link to={"/login/register/"}>アカウント(管理者)を作成</Link>
            <Link to={"/login/reset/"}>パスワードを忘れた場合</Link>
            <Link to={"/login/confirm/"}>認証コードを入力する</Link>
          </div>
          {bProcessing ? (
            <LoginginButton
              loading
              loadingPosition="start"
              startIcon={<CircleOutlinedIcon />}
              fullWidth
              variant="outlined"
              color="primary"
            >
              ログイン中・・・
            </LoginginButton>
          ) : (
            <SubmitButton
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleLogin()}
            >
              ログイン
            </SubmitButton>
          )}
        </MyForm>
      </MyPaper>
      <Card variant="outlined">
        <CardContent sx={{ bgcolor: "#fff8dc" }}>
          <Typography variant="h6" color="text:secondary">
            注意事項
          </Typography>
          <Box>
            <List sx={{ listStyleType: "disc", ml: 3 }} dense>
              <NotesItem>
                システムの更新やメンテナンスが行われる際には、別途お知らせいたしますが、緊急の場合には事前告知なく作業を行うことがあります。
              </NotesItem>
              <NotesItem>
                <a
                  href={process.env.REACT_APP_URL_EULA}
                  target="_blank"
                  rel="noreferrer"
                >
                  利用規約
                </a>
              </NotesItem>
            </List>
          </Box>
        </CardContent>
      </Card>
      <Box mt={8}>
        <Copyright />
      </Box>
      {loginUser ? (
        <>
          <ForceChangePassDialog user={loginUser} />
          <TotpDialog user={loginUser} />
        </>
      ) : null}
      <Dialog
        open={openMsgDialog}
        onClose={() => setOpenMsgDialog(false)}
        aria-labelledby="msg-dialog-title"
      >
        <DialogTitle>確認</DialogTitle>
        <DialogContent>
          <DialogContentText>
            パスワードを更新しました。
            <br />
            新しいパスワードでログインしてください。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMsgDialog(false)}>閉じる</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default LoginPage;
